import { AIDE_MATERIELLE_FIXE } from './casConventionCodes';

export const OPTIONS_AIDE_MATERIELLE_ASSISTANT = [
  { key: 1, text: 'Proportionnelle à nos facultés respectives' },
  { key: AIDE_MATERIELLE_FIXE, text: 'Fixée à la hauteur de' },
  { key: 3, text: 'Autre' },
];

export const OPTIONS_REGIME_BIEN_ASSISTANT = [
  { key: 1, text: 'Le régime légal de la séparation des patrimoines' },
  {
    key: 2,
    text: "Le régime de l'indivision des biens que nous acquerrons, ensemble ou séparément, à partir de l'enregistrement du PACS",
  },
  { key: 3, text: 'Autre' },
];
